import { useState } from "react";
import { CiCircleRemove } from "react-icons/ci";
import { Formik, Field, Form } from "formik";
import * as Yup from "yup";
import { FaRegSave } from "react-icons/fa";
import { ImCancelCircle } from "react-icons/im";
import ButtonLightTextIcon from "../../../components/ui/ButtonLightTextIcon";
import ButtonTextIcon from "../../../components/ui/ButtonTextIcon";
import { API_URL } from "../../../utilities/constants";
import { useUI } from "../../../context/ui";

const Label = ({ title, required, style }) => (
  <p
    className="color-primary f-w-600"
    style={{ paddingBottom: "5px", ...style }}
  >
    {title}
    {required && <span style={{ color: "red", marginLeft: "4px" }}>*</span>}
  </p>
);

const AddTemplete = ({ setShow, callback }) => {
  const [subjectCount, setSubjectCount] = useState(0);
  const [bodyCount, setBodyCount] = useState(0);
  const {
    addNotification,
    addToastMessage,
    setNewNotification,
    setShowNotification,
  } = useUI();

  const initialValues = { name: "", subject: "", body: "" };

  const formValidation = Yup.object().shape({
    name: Yup.string()
      .min(3, "Name must be at least 3 characters")
      .max(50, "Name can't exceed 50 characters")
      .matches(/^[a-zA-Z\s]+$/, "Name can only contain letters and spaces")
      .required("Name is required"),
    subject: Yup.string()
      .min(5, "Subject must be at least 5 characters")
      .max(50, "Subject can't exceed 50 characters")
      .required("Subject is required"),
    body: Yup.string()
      .min(10, "Body must be at least 10 characters")
      .max(150, "Body can't exceed 150 characters")
      .required("Body is required"),
  });

  const handleOnSubmit = async (values, { setSubmitting }) => {
    try {
      const response = await fetch(API_URL + `/api/1.0.0/template`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-JWT-Assertion": localStorage.getItem("token"),
        },
        body: JSON.stringify(values),
      });

      if (response.ok) {
        callback();
        addToastMessage({
          status: true,
          message: "Successfully Created Template.",
        });
        addNotification({
          id: Date.now(),
          message: "Template Created!",
          status: true,
        });
        setShow(false);
      } else {
        const errorData = await response.json();
        addToastMessage({
          status: false,
          message: errorData.responseDescription || "Error creating template.",
        });
      }
    } catch {
      setNewNotification(true);
      setShowNotification(true);
      addNotification({
        id: Date.now(),
        message: "Error creating template!",
        status: false,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="responsive-container flex pos-rel"
      style={{ minHeight: "60vh", flexDirection: "column" }}
    >
      <CiCircleRemove
        className="cursor-pointer transition hover-color-primary"
        onClick={() => setShow(false)}
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          fontSize: "32px",
        }}
      />
      <h6 className="t-a-c color-primary">Push Notification</h6>

      <Formik
        initialValues={initialValues}
        validationSchema={formValidation}
        onSubmit={handleOnSubmit}
      >
        {({ errors, touched, isSubmitting, values, handleChange }) => (
          <Form
            className="flex responsive-container"
            style={{ gap: "12px", padding: "20px", width: "400px" }}
          >
            <div className="col-1-1">
              <Label title="Name" required />
              <Field
                type="text"
                name="name"
                placeholder="Enter name"
                className={errors.name && touched.name ? "error" : ""}
                style={{ backgroundColor: "#f1f1f1" }}
              />
              {errors.name && touched.name && (
                <p style={{ color: "red", fontSize: "12px" }}>{errors.name}</p>
              )}
            </div>

            <div className="col-1-1">
              <Label title="Subject" required />
              <Field
                type="text"
                name="subject"
                placeholder="Enter subject"
                maxLength={50}
                value={values.subject}
                onChange={(e) => {
                  setSubjectCount(e.target.value.length);
                  handleChange(e);
                }}
                className={errors.subject && touched.subject ? "error" : ""}
                style={{ backgroundColor: "#f1f1f1" }}
              />
              <p style={{ fontSize: "12px", textAlign: "right" }}>
                {50 - subjectCount} characters left
              </p>
              {errors.subject && touched.subject && (
                <p style={{ color: "red", fontSize: "12px" }}>
                  {errors.subject}
                </p>
              )}
            </div>

            <div className="col-1-1">
              <Label title="Body" required />
              <Field
                as="textarea"
                name="body"
                placeholder="Enter notification body"
                maxLength={150}
                value={values.body}
                onChange={(e) => {
                  setBodyCount(e.target.value.length);
                  handleChange(e);
                }}
                className={errors.body && touched.body ? "error" : ""}
                style={{ backgroundColor: "#f1f1f1" }}
              />
              <p style={{ fontSize: "12px", textAlign: "right" }}>
                {150 - bodyCount} characters left
              </p>
              {errors.body && touched.body && (
                <p style={{ color: "red", fontSize: "12px" }}>{errors.body}</p>
              )}
            </div>

            <div className="flex center-center col-1-1" style={{ gap: "20px" }}>
              <ButtonLightTextIcon
                title="Cancel"
                type="button"
                icon={<ImCancelCircle />}
                onClick={() => setShow(false)}
              />
              <ButtonTextIcon
                title={isSubmitting ? "Submitting..." : "Submit"}
                type="submit"
                icon={<FaRegSave />}
                disabled={isSubmitting}
              />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AddTemplete;
